'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _widgetData = require('../widget-data/reducers/widgetData');

var _widgetData2 = _interopRequireDefault(_widgetData);

var _refreshedWidgetData = require('../widget-data/reducers/refreshedWidgetData');

var _refreshedWidgetData2 = _interopRequireDefault(_refreshedWidgetData);

var _prospectUtks = require('./prospectUtks');

var _prospectUtks2 = _interopRequireDefault(_prospectUtks);

var _widgetUi = require('./widgetUi');

var _widgetUi2 = _interopRequireDefault(_widgetUi);

var _emailCaptureReducer = require('../email-capture/emailCaptureReducer');

var _emailCaptureReducer2 = _interopRequireDefault(_emailCaptureReducer);

var _availabilityMessageTimeouts = require('../availability/reducers/availabilityMessageTimeouts');

var _availabilityMessageTimeouts2 = _interopRequireDefault(_availabilityMessageTimeouts);

var _requestStatus = require('../request-status/reducers/requestStatus');

var _requestStatus2 = _interopRequireDefault(_requestStatus);

var _conversationsVisitor = require('./conversationsVisitor');

var _conversationsVisitor2 = _interopRequireDefault(_conversationsVisitor);

var _currentChannel = require('../current-channel/reducers/currentChannel');

var _currentChannel2 = _interopRequireDefault(_currentChannel);

var _clientData = require('../client-data/reducers/clientData');

var _clientData2 = _interopRequireDefault(_clientData);

var _messages = require('../messages/reducers/messages');

var _messages2 = _interopRequireDefault(_messages);

var _responders = require('../responders/reducers/responders');

var _responders2 = _interopRequireDefault(_responders);

var _visitorThreadHistories = require('../thread-histories/reducers/visitorThreadHistories');

var _visitorThreadHistories2 = _interopRequireDefault(_visitorThreadHistories);

var _stubbedThreadHistory = require('../stubbed-thread-history/reducers/stubbedThreadHistory');

var _stubbedThreadHistory2 = _interopRequireDefault(_stubbedThreadHistory);

var _tracker = require('../usage-tracking/reducers/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

var _agentTypingStatesReducer = require('../typing-indicators/reducers/agentTypingStatesReducer');

var _agentTypingStatesReducer2 = _interopRequireDefault(_agentTypingStatesReducer);

var _botTypingStatesReducer = require('../typing-indicators/reducers/botTypingStatesReducer');

var _botTypingStatesReducer2 = _interopRequireDefault(_botTypingStatesReducer);

var _fileUploads = require('../file-uploads/reducers/fileUploads');

var _fileUploads2 = _interopRequireDefault(_fileUploads);

var _fileUploadsErrors = require('../file-uploads/reducers/fileUploadsErrors');

var _fileUploadsErrors2 = _interopRequireDefault(_fileUploadsErrors);

var _resolvedAttachments = require('../resolved-attachments/reducers/resolvedAttachments');

var _resolvedAttachments2 = _interopRequireDefault(_resolvedAttachments);

var _createThreadStatus = require('../threads/reducers/createThreadStatus');

var _createThreadStatus2 = _interopRequireDefault(_createThreadStatus);

var _pubSubClient = require('../pubsub/reducers/pubSubClient');

var _showingPageTitleNotification = require('../page-title-notifications/reducers/showingPageTitleNotification');

var _showingPageTitleNotification2 = _interopRequireDefault(_showingPageTitleNotification);

var _iframeUuid = require('../iframeUuid/reducers/iframeUuid');

var _iframeUuid2 = _interopRequireDefault(_iframeUuid);

var _gdpr = require('../gdpr/reducers/gdpr');

var _gdpr2 = _interopRequireDefault(_gdpr);

var _currentView = require('../current-view/reducers/currentView');

var _currentView2 = _interopRequireDefault(_currentView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  agentTypingStates: _agentTypingStatesReducer2.default,
  availabilityMessageTimeouts: _availabilityMessageTimeouts2.default,
  botTypingStates: _botTypingStatesReducer2.default,
  clientData: _clientData2.default,
  conversations: _conversationsVisitor2.default,
  createThreadStatus: _createThreadStatus2.default,
  currentChannel: _currentChannel2.default,
  currentView: _currentView2.default,
  emailCapture: _emailCaptureReducer2.default,
  gdpr: _gdpr2.default,
  messages: _messages2.default,
  prospectUtks: _prospectUtks2.default,
  pubSubClient: _pubSubClient.pubSubClient,
  requestStatus: _requestStatus2.default,
  resolvedAttachments: _resolvedAttachments2.default,
  responders: _responders2.default,
  fileUploads: _fileUploads2.default,
  fileUploadsErrors: _fileUploadsErrors2.default,
  showingPageTitleNotification: _showingPageTitleNotification2.default,
  stubbedThreadHistory: _stubbedThreadHistory2.default,
  threadHistories: _visitorThreadHistories2.default,
  tracker: _tracker2.default,
  iframeUuid: _iframeUuid2.default,
  refreshedWidgetData: _refreshedWidgetData2.default,
  widgetData: _widgetData2.default,
  widgetUi: _widgetUi2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/visitorUIRootReducer.js
// module id = 1272
// module chunks = 3